<template>
  <div>
    <div>

      <!--evaluaciones-->
      <div class="vx-row" v-if="arrayMaterias.length > 0">
        <div class="vx-col w-full sm:w-full md:w-full lg:w-full xl:w-full mb-6">
          <vx-card title="Evaluaciones Pendientes">
            <EstudianteEvaluacionesPendientesVue :arrayMaterias="arrayMaterias"/>
          </vx-card>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full sm:w-full md:w-1/2 lg:w-2/3 xl:w-2/3 mb-6">
          <vx-card  title="Tickets" class="columna">
            <vs-alert color="danger" v-if="cantidadMensajesVistos < cantidadMensajesNovistos">
              <p class="text-center">Mensajes no vistos {{cantidadMensajesNovistos.length}}</p>
            </vs-alert>
            <ticketEstudianteVue />
          </vx-card>
        </div>
        <div class="vx-col w-full sm:w-full md:w-1/2 lg:w-1/3 xl:w-1/3 mb-6">
          <vx-card  title="Tareas" class="columna">
            <div class="vx-row">
              <div class="vx-col w-full sm:w-full md:w-full  lg:w-full  xl:w-full  mb-6">
                <div class="flex items-center bg-white border rounded-sm overflow-hidden shadow h-full">
                  <div class="p-4 bg-warning">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 text-white" fill="none"
                        viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2">
                      </path>
                    </svg>
                  </div>
                  <div class="px-4 text-gray-700">
                      <h3 class="text-sm tracking-wider">Tareas Pendientes</h3>
                      <p class="text-3xl">{{ tareasPendientes }}</p>
                  </div>
                </div>
              </div>
              <div class="vx-col w-full sm:w-full  md:w-full  lg:w-full  xl:w-full  mb-6 mt-3">
                <div class="flex items-center bg-white border rounded-sm overflow-hidden shadow h-full">
                  <div class="p-4 bg-success">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 text-white" fill="none"
                        viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4">
                      </path>
                    </svg>
                  </div>
                  <div class="px-4 text-gray-700">
                    <h3 class="text-sm tracking-wider">Tareas Enviadas</h3>
                    <p class="text-3xl">{{ tareasRealizadas }}</p>
                  </div>
                </div>
              </div>
          </div>

            <!-- <vs-list>
              <vs-list-header icon-pack="feather" icon="icon-file-text" title="Tareas pendientes"
                color="warning"></vs-list-header>
              <div v-for="(item, index) in cursos" :key="index">
                <div class="ml-8" v-if="item.tareas_pendientes.length != 0">
                  <vs-list-item v-if="item.tareas_pendientes.length != 0" icon-pack="feather" icon="icon-airplay"
                    :title="item.cursos.nombre">
                  </vs-list-item>
                  <div v-for="(tarea, ind) in item.tareas_pendientes" :key="ind">
                    <div class="ml-12 vs-list--subtitle">
                      <div class="vs-row">
                        <feather-icon icon="FileTextIcon" class="inline-block m-3" icon-color="success"
                          svgClasses="w-5 h-5" />
                        <span class="text-primary">{{ tarea.descripcion }}</span>
                      </div>
                      <div class="flex flex-row ml-4 justify-between">
                        <span class="text-secundary">Fecha de inicio: {{ tarea.fecha_inicio }}</span> <span
                          class="text-danger">Fecha de final: {{ tarea.fecha_final }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <vs-list-header icon-pack="feather" icon="icon-file-text" title="Tareas entregadas"
                color="success"></vs-list-header>
              <div v-for="(item, index) in cursos" :key="index">
                <div class="ml-8" v-if="item.tareas_realizadas.length != 0">
                  <vs-list-item v-if="item.tareas_realizadas.length != 0" icon-pack="feather" icon="icon-airplay"
                    :title="item.cursos.nombre">
                  </vs-list-item>
                  <div v-for="(tarea, ind) in item.tareas_realizadas" :key="ind">
                    <div class="ml-12 vs-list--subtitle">
                      <div class="vs-row">
                        <feather-icon icon="FileTextIcon" class="inline-block m-3" icon-color="success"
                          svgClasses="w-5 h-5" />
                        <span class="text-primary">{{ tarea.descripcion }}</span>
                      </div>
                      <div class="flex flex-row ml-4 justify-between">
                        <span class="text-secundary">Fecha de inicio: {{ tarea.fecha_inicio }}</span> <span
                          class="text-success">Fecha de final: {{ tarea.fecha_final }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </vs-list> -->
          </vx-card>
        </div>
      </div>
      <!-- <vs-card style="margin-top:20px;">
        <vs-tabs>
          <vs-tab label="Evaluaciones pendientes" icon-pack="feather" icon="icon-file" @click="getMaterias();menu =0;" >
          </vs-tab>
          <vs-tab label="Notificaciones" icon-pack="feather" icon="icon-bell" @click="menu =1;">
          </vs-tab>
          <vs-tab v-if="cantidadMensajesVistos < cantidadMensajesNovistos" label="Tickets(Mensajes no leidos)" color="red"
            icon-pack="feather" icon="icon-edit" @click="menu =2;">
            <ticketEstudianteVue />
          </vs-tab>
          <vs-tab v-else label="Tickets" color="red" icon-pack="feather" icon="icon-edit" @click="menu =3;">
            <ticketEstudianteVue />
          </vs-tab>
        </vs-tabs>
        <br><br>
      </vs-card> -->
    </div>
  </div>
</template>
<script>
import {
  mapState
} from 'vuex'
const ticketEstudianteVue                 = () => import('@/views/estudiantes/ticketEstudiante.vue')
const EstudianteEvaluacionesPendientesVue = () => import('./estudiante/Evaluaciones/EstudianteEvaluacionesPendientes.vue')
export default {
  components: {
    ticketEstudianteVue,
    EstudianteEvaluacionesPendientesVue,
  },
  computed: {
    ...mapState(['cursos'])
  },
  data() {
    return {
      cantidadMensajesNovistos: 0,
      cantidadMensajesVistos: 0,
      usuario:[],
      arrayMaterias:[],
      tareasPendientes: 0,
      tareasRealizadas: 0,
    }
  },
  created(){
    let me = this;
    this.usuario = JSON.parse(localStorage.getItem('usuario'))
  },
  mounted(){
    let me = this;
    this.getMaterias()
    this.getTicketsAbiertos()
    this.getCantidadTareas()
  },
  methods:{
    getMaterias(){
      let me = this
      this.$http.get(this.$server_url + `estudianteMetodosGet?getMateriasAsignadas=1&idusuario=${me.usuario.idusuario}`)
      .then(function (res) {
        var datos = []
        datos     = res.data
        if(datos.length == 0){
          me.arrayMaterias = datos
        }else{
          //en la propiedad accion que tiene 0 cambiar por false
          datos.forEach(element => {
            element.accion = false
          });
          me.arrayMaterias = datos
        }
      })
      .catch(function (err) {
        me.$vs.notify({
          title: 'Error',
          text: 'Error al cargar las materias',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
        console.log(err)
      })
    },
    getCantidadTareas(){
      //api:get
      let me = this;
      this.$http.get(this.$server_url + `estudianteMetodosGet?getTareasEstudiante=1&idusuario=${me.usuario.idusuario}`)
        .then(function (res) {
          console.log(res.data)
          me.tareasPendientes         = res.data.pendientes
          me.tareasRealizadas         = res.data.realizadas
        })
        .catch(function (error) {
          console.log(error + ' error');
        })
    },
    getTicketsAbiertos() {
      let me = this;
      this.$http.get(this.$server_url + 'ticket?cantidadTicketNotificacion=yes&id=' + me.usuario.idusuario)
        .then(function (res) {
          console.log(res.data)
          if (res.data.length > 0) {
            me.cantidadMensajesNovistos = res.data[0].cantidad
            me.cantidadMensajesVistos   = res.data[0].cantidad_tickets_usuario
          }
        })
        .catch(function (error) {
          console.log(error + ' error');
        })
    },
  }
}
</script>
<style scoped>
/*heigth de 500 y que se scroll .columna*/
.columna{
  height: 500px;
  overflow-y: scroll;
  background: rgb(255, 255, 255);
}
</style>
